import p5 from "p5";
import { TWO_PI, PHI, SQR_2, GA, SGR } from "./local_mods/math_constants.js";
import { image_data } from "./media_data.js";
import {
  frand_rng,
  arr_pick,
  fib_num,
  render_dims,
  fx_shuffle_arr,
  calculateAspectRatioFit,
  bias_arr_pick,
  lerp,
  frand_rng_int,
} from "./local_mods/util.js";

const init_scene = function () {
  const scene_OPR = PHI;
  const OPR = scene_OPR.nat;
  const i_OPR = scene_OPR.inv;

  const pn_seed = Math.floor(frand_rng(4294967296));
  const pn_incr = 11;

  // select and def vars for canvas aspect ratio
  const aspect = {};
  aspect.name = "Square";
  aspect.layout = "square";
  aspect.ratio = { w: 1, h: 1 };

  aspect.dims = render_dims[aspect.layout];

  // face mask archetype
  const mask_img_is_figure = arr_pick([0, 1]);
  const mask_img_data = arr_pick(image_data);

  const layers = [];
  const num_layers = bias_arr_pick([7, 4, 11, 3], OPR);

  let face_render_img_data = [];
  for (let i = 0; i < num_layers; i++) {
    face_render_img_data.push(arr_pick(image_data));
  }

  let ellipse_on = bias_arr_pick([true, false], i_OPR);

  let rot_alignment_fact = arr_pick([3, 4, 7, 11]);
  let rot_pn_offset = i_OPR ** rot_alignment_fact;

  const interactivity_is = false;

  const clock_face_radius_fact = { max: 4, min: 9 };

  // const bkg_clr = 0;
  const bkg_clr = bias_arr_pick([0, 255, 255 * i_OPR ** 5], OPR);

  let preview_is_done = false;

  return {
    aspect,
    bkg_clr,
    mask_img_is_figure,
    mask_img_data,
    face_render_img_data,
    clock_face_radius_fact,
    fxhash,
    OPR,
    i_OPR,
    scene_OPR,
    layers,
    num_layers,
    pn_seed,
    pn_incr,
    ellipse_on,
    rot_alignment_fact,
    rot_pn_offset,
    interactivity_is,
    preview_is_done,
  };
};
export { init_scene };
